var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndpointSecurityServicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.847656,
    y: 0.0564575,
    width: 72.5033,
    height: 72.5033,
    rx: 10.3576,
    fill: "#1F6256"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7329 35.7905L27.7773 29.8349L33.7329 23.8792L31.9203 22.0667L24.1521 29.8349L31.9203 37.6031L33.7329 35.7905ZM40.4653 48.7375L46.421 42.7819L40.4653 36.8263L42.2779 35.0137L50.0461 42.7819L42.2779 50.5501L40.4653 48.7375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndpointSecurityServicesIcon);
export default __webpack_public_path__ + "static/media/EndpointSecurityServicesIcon.c285b3485185a01b54d6911e0b5654a0.svg";
export { ForwardRef as ReactComponent };